import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import * as actions from '../../redux/actions/subscription'
import { useMemo, useEffect } from 'react'
import { bindActionCreators } from 'redux'

export function useSubscription(subscriptionId) {
  const subscriptionState = useSelector(
    (state) => state.subscription,
    shallowEqual
  )
  const dispatch = useDispatch()

  const loadSubscription = useMemo(
    () => bindActionCreators(actions.loadSubscription, dispatch),
    [dispatch]
  )

  useEffect(() => {
    if (!subscriptionState || subscriptionState.data.id !== subscriptionId) {
      loadSubscription(subscriptionId)
    }
  }, [subscriptionId]) // eslint-disable-line react-hooks/exhaustive-deps

  const skipSubscription = useMemo(
    () =>
      bindActionCreators(actions.skipSubscription(subscriptionId), dispatch),
    [dispatch, subscriptionId]
  )

  const cancelSubscription = useMemo(
    () =>
      bindActionCreators(actions.cancelSubscription(subscriptionId), dispatch),
    [dispatch, subscriptionId]
  )

  const updateSubscription = useMemo(
    () =>
      bindActionCreators(actions.updateSubscription(subscriptionId), dispatch),
    [dispatch, subscriptionId]
  )

  const pauseSubscription = useMemo(
    () =>
      bindActionCreators(actions.pauseSubscription(subscriptionId), dispatch),
    [dispatch, subscriptionId]
  )

  const resumeSubscription = useMemo(
    () =>
      bindActionCreators(actions.resumeSubscription(subscriptionId), dispatch),
    [dispatch, subscriptionId]
  )

  return {
    subscription: subscriptionState.data,
    isLoaded: subscriptionState.isLoaded,
    isFetching: subscriptionState.isFetching,
    skipSubscription,
    cancelSubscription,
    updateSubscription,
    pauseSubscription,
    resumeSubscription,
  }
}
